/**
 * Receiver - Handles incoming broadcast messages from the server.
 *
 * Project code registers handlers by assigning functions:
 *   receiver.noteUpdated = (data, conflict) => { ... }
 *
 * When a broadcast arrives:
 * - If no dirty state for the record: handler(data)
 * - If dirty state exists (Conflict B): handler(data, { local, remote, key })
 * - After sync resolution: handler(data, { resolution: 'merged' | 'overwritten' | ... })
 */
export class Receiver {

}

export default Receiver;
